import { useMemo } from "react";
import { isFeatureAvailable, Feature } from "@functions/featureAvailability";
import { useCurrentWorkspaceUsage } from "@/store";

/**
 * Hook to check if a feature is enabled for the current workspace.
 * Uses the workspace usage data to determine feature availability.
 *
 * @param feature - The feature to check availability for
 * @returns true if the feature is enabled for the current workspace, false otherwise
 */
export const useFeatureEnabled = (feature: Feature): boolean => {
    const currentWorkspaceUsage = useCurrentWorkspaceUsage();

    const isEnabled = useMemo(() => {
        if (!currentWorkspaceUsage) {
            return false;
        }
        return isFeatureAvailable(feature, currentWorkspaceUsage);
    }, [currentWorkspaceUsage, feature]);

    return isEnabled;
};

// Re-export Feature enum for convenience
export { Feature } from "@functions/featureAvailability";
